import { Badge } from '@chakra-ui/react';
import { StudentCourseEnrolmentEventType } from '@duke-hq/svc-api-db';

interface EventChipProps {
  eventType: StudentCourseEnrolmentEventType;
}

const chipConfig: Record<StudentCourseEnrolmentEventType, { label: string; colorScheme: string }> =
  {
    COURSE_ENROLMENT_CREATED: { label: 'Enrolled', colorScheme: 'green' },
    COURSE_ENROLMENT_UPDATED: { label: 'Updated', colorScheme: 'blue' },
    COURSE_SEGMENT_UPDATED: { label: 'Segment Updated', colorScheme: 'blue' },
    COURSE_ENROLMENT_WITHDRAWN: { label: 'Withdrawn', colorScheme: 'orange' },
    COURSE_ENROLMENT_DELETED: { label: 'Deleted', colorScheme: 'red' },
    COURSE_ENROLMENT_RESTORED: { label: 'Restored', colorScheme: 'blue' },
    LLN_COMPLETED: { label: 'LLN Done', colorScheme: 'purple' },
    SEMESTER_1_COMPLETED: { label: 'Sem 1 Done', colorScheme: 'teal' },
    SEMESTER_2_COMPLETED: { label: 'Sem 2 Done', colorScheme: 'cyan' },
    COURSE_ENROLMENT_COMPLETED: {
      label: 'Course Enrolment Done',
      colorScheme: 'green',
    },
    DOCUMENT_GENERATED: { label: 'Document generated', colorScheme: 'green' },
    COURSE_ENROLMENT_TRANSFERRED: { label: 'Transferred', colorScheme: 'green' },
    ONBOARDING_STARTED: { label: 'Onboarding Started', colorScheme: 'blue' },
    ONBOARDING_COMPLETED: { label: 'Onboarding Completed', colorScheme: 'green' },
    FIRST_CONVERSATION_STARTED: {
      label: 'First Conversation Started',
      colorScheme: 'blue',
    },
    FIRST_CONVERSATION_COMPLETED: {
      label: 'First Conversation Completed',
      colorScheme: 'green',
    },
    FIRST_ASSESSMENT_STARTED: {
      label: 'First Assessment Started',
      colorScheme: 'blue',
    },
    FIRST_ASSESSMENT_SUBMITTED: {
      label: 'First Assessment Submitted',
      colorScheme: 'teal',
    },
    FIRST_ASSESSMENT_COMPLETED: {
      label: 'First Assessment Completed',
      colorScheme: 'green',
    },
    ASSESSMENT_RESET: { label: 'Assessment Reset', colorScheme: 'red' },
    ASSESSMENT_OUTCOME_UPDATED: {
      label: 'Assessment Outcome Updated',
      colorScheme: 'purple',
    },
    UNIT_CREDIT_TRANSFERRED: {
      label: 'Unit Credit Transferred',
      colorScheme: 'green',
    },
    COURSE_ENROLMENT_PAUSED: { label: 'Paused', colorScheme: 'yellow' },
    COURSE_ENROLMENT_RESUMED: { label: 'Resumed', colorScheme: 'blue' },
    ASSESSMENT_MARKED: { label: 'Assessment Marked', colorScheme: 'purple' },
    ASSESSMENT_SUBMITTED: { label: 'Assessment Submitted', colorScheme: 'purple' },
  };

function EventChip({ eventType }: EventChipProps): React.ReactElement {
  const config = chipConfig[eventType] || {
    label: 'Unknown',
    colorScheme: 'gray',
  };

  return (
    <Badge colorScheme={config.colorScheme} fontSize="xs">
      {config.label}
    </Badge>
  );
}

export default EventChip;
